App = {};

Components = {
    Energy: {
        Common: {},
        Engineer: {},
        Manager: {}
    }
};

Libs = {};

Models = {};
